import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './FavouriteButton';
import { getDeviationPatchedWithStoreState } from '../../../../CollectionPanel/redux/selectors';
import { changeFaveCustom } from '../../../../CollectionPanel/redux/actionCreators';

type StateProps = Pick<Props, never>;
type DispatchProps = Pick<Props, 'onChangeFave'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, { deviation }) => {
  const patchedDeviation = getDeviationPatchedWithStoreState(state, deviation);
  return {
    deviation: patchedDeviation,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onChangeFave: changeFaveCustom,
};

export default connect(mapStateToProps, mapDispatchToProps);
